import React from "react";
import { ThemeProvider } from "styled-components/macro";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import ThemeSelector from "./layout/ThemeSelector";
import Theme from "./layout/global-theme";
import { RootProvider } from "./provider/RootProvider";

//create library for font awesome resources.
library.add(faUser);

function App({ store }) {
  return (
    <ThemeProvider theme={Theme}>
      <RootProvider>
        <div id="main-container">
          <ThemeSelector store={store} />
        </div>
      </RootProvider>
    </ThemeProvider>
  );
}

export default App;
